// extracted by mini-css-extract-plugin
export var mainNav = "logo-bar-module--mainNav--76itI";
export var mymotto = "logo-bar-module--mymotto--rGupz";
export var mymottovisible = "logo-bar-module--mymottovisible--hyb2R";
export var tagline = "logo-bar-module--tagline--458rp";